const handleFormJustVoting = function () {
  const wrappers = document.querySelectorAll('.form__wrapper_just_vote');

  if (wrappers.length > 0) {
    wrappers.forEach((wrapper) => {
      const submitBtns = wrapper.querySelectorAll('.send-just-vote');

      submitBtns.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();

          // W obrębie danego bloku teaser znajdź właściwy tytuł
          const teaser = btn.closest('.teaser--vote');
          const selectedCarEl = teaser.querySelector('.teaser__text > h4');
          const selectedCar = selectedCarEl ? selectedCarEl.innerText.trim() : '';

          // Przygotowanie danych
          const data = {
            selectedCar: selectedCar,
            button: 'vote'
          };

          let formIsValid = true;
          // Możesz dodać dodatkową walidację

          if (formIsValid && data.selectedCar) {
            // Wyświetl spinner w obrębie aktualnego wrappera
            createSpinner(wrapper);

            // Pobierz element formularza w obrębie wrappera
            const formEl = wrapper.querySelector('form');
            const url = formEl.getAttribute('data-url');

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            })
              .then((response) => response.text())
              .then((html) => {
                document.querySelectorAll('.btn-just-vote').forEach((btn) => {
                  btn.setAttribute('disabled', 'true');
                });

                const articleFormDiv = document.createElement('div');
                articleFormDiv.className = 'article__form form--visible';
                articleFormDiv.innerHTML = html;

                const teasers = document.querySelector('.teasers');
                if (!teasers) {
                  console.warn('Brak elementu .teasers w dokumencie');
                  return;
                }
                teasers.appendChild(articleFormDiv);

                const teasersWrapper = teasers.querySelector('.teasers__wrapper');
                if (!teasersWrapper) {
                  console.warn('Brak elementu .teasers__wrapper w .teasers');
                  return;

                }
                teasersWrapper.style.display = 'none';
              })
              .catch((err) => {
                console.error('Błąd podczas wysyłania głosu:', err);
              });
          }
        });
      });
    });
  }
};

handleFormJustVoting();
